import React from 'react';
import styles from './index.module.css';

const PageLoader = () => {
  return <div className={styles.pageLoader} />;
};

export default PageLoader;
